import React from 'react';
import { useParams } from 'react-router-dom';
import { VideoPostView } from '.';
import { PracticeWidget } from '../Practice';
import PageContainer from '../layout/PageContainer';

const VideoPostDetail = () => {
    const { id } = useParams();

    return (
        <PageContainer>
            <VideoPostView videoPostId={id} />
            {id && (
                <PracticeWidget 
                    contentType="ContentVideoPost" 
                    contentId={id} 
                />
            )}
        </PageContainer>
    );
};

export default VideoPostDetail;
